import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Card,
  Avatar,
  Grid,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import ApplicationDetailsDialog from "./ApplicationDetailsDailog";
import "./AlumniHighlight.css";
import Confettiful from "./Confettiful";

const StarAlumniHighlight = ({ alumni, staralumniRequests }) => {
  const [openDetails, setOpenDetails] = useState(false);
  const confettiContainerRef = useRef(null);

  useEffect(() => {
    if (confettiContainerRef.current) {
      new Confettiful(confettiContainerRef.current);
    }
  }, []);

  return (
    <div>
      <div ref={confettiContainerRef} class="js-container container">
        <Card
          sx={{
            textAlign: "center",
            padding: 4,
            background: "linear-gradient(135deg, #0A192F 20%, #112D4E 80%)", // Deep navy gradient
            color: "white",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
            maxWidth: 500,
            height: 420,
            margin: "auto",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Circular Avatar with Banner */}
          <Box
            sx={{
              margin: "auto",
              position: "relative",
              width: 150,
              height: 150,
            }}
          >
            {/* Avatar */}
            <Avatar
              src={alumni?.largeAvatar || "/default-avatar.png"}
              alt="Star Alumni"
              sx={{
                width: "100%",
                height: "100%",
                position: "relative",
                zIndex: 2,
                overflow: "hidden",
                border: "5px solid #FFD700", // Gold border
                borderRadius: "50%",
                boxShadow: "0 0 15px #FFD700", // Glow effect
              }}
            />
          </Box>

          {/* Congratulations Text */}
          <Typography
            variant="h4"
            sx={{
              fontFamily: "serif",
              marginTop: 2,
              fontWeight: "bold",
              textShadow: "0 0 15px rgba(255, 215, 0, 0.8)",
              color: "#FFD700", // Gold color
            }}
          >
            Congratulations
          </Typography>

          {/* Alumni Name on a Gold Banner */}
          <Box
            sx={{
              background: "#CFAE60",
              color: "#0A192F",
              padding: "8px 16px",
              borderRadius: "5px",
              display: "inline-block",
              fontWeight: "bold",
              fontSize: "18px",
              marginTop: 2,
              textTransform: "uppercase",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
            }}
          >
            {alumni?.name || "Star Alumni"}
          </Box>

          {/* Achievement Message */}
          <Typography
            variant="body2"
            sx={{
              marginTop: 2,
              padding: "0 16px",
              fontStyle: "italic",
              textShadow: "0 0 5px rgba(255, 255, 255, 0.4)",
              color: "#E3E3E3", // Soft white-gray
            }}
          >
            Congratulations! You have been recognized as a "Star Alumni" for
            your outstanding achievements and contributions.
          </Typography>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            sx={{ marginTop: 2 }}
          ></Grid>

          <ApplicationDetailsDialog
            open={openDetails}
            onClose={() => setOpenDetails(false)}
            applicationId={staralumniRequests[0]?.id}
          />
        </Card>
      </div>
    </div>
  );
};

export default StarAlumniHighlight;
